





















import { Vue, Component, Prop } from 'vue-property-decorator'
import SlidePreviewTail from 'components/presenter/item/topic/viewer/PreviewTail.vue'

@Component({
  components: {
    SlidePreviewTail
  }
})
export default class ItemTopicViewerSlidesViewerGrid extends Vue {

  @Prop()
  readonly slides!: Json[]

  @Prop()
  readonly currSlideId!: string

  @Prop()
  readonly seed!: string | undefined

  @Prop({ default: () => { return {} } })
  readonly params!: Json

  @Prop({ default: () => { return {} } })
  readonly response!: Json

  get currSlideIndex () {
    return this.slides.findIndex((s: Json) => s.id === this.currSlideId)
  }

  select (slide: Json) {
    if (slide) {
      this.$emit('slide-select', slide.id)
    }
  }
}
